import React from "react";
import { Sparkles, MousePointerClick, ShoppingBag, Trophy, Star, Coins } from "lucide-react";
import { ViewModal } from "./ViewModal";
import { evaluateAchievements } from "../game/achievements";

const ICONS = {
  spark: Sparkles,
  click: MousePointerClick,
  shop: ShoppingBag,
  trophy: Trophy,
  era: Star,
  berry: Coins,
};

const AchievementRow = ({ a }) => {
  const Icon = ICONS[a.icon] || Trophy;
  return (
    <div
      className={`relative flex items-center gap-4 p-4 border ${
        a.unlocked ? "border-[#FFD400]" : "border-[#1e1e1e]"
      }`}
      style={{
        backgroundColor: "#111",
        borderRadius: 4,
      }}
      data-testid={`achievement-${a.id}`}
      data-unlocked={a.unlocked ? "true" : "false"}
    >
      <div
        className={`w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-sm ${
          a.unlocked ? "" : "opacity-30"
        }`}
        style={{
          backgroundColor: a.unlocked ? "#FFD400" : "#181818",
          border: a.unlocked ? "1px solid #FFD400" : "1px solid #2a2a2a",
        }}
      >
        <Icon size={22} color={a.unlocked ? "#111" : "#666"} />
      </div>
      <div className="flex-1 min-w-0">
        <div
          className={`text-sm font-black uppercase tracking-widest ${
            a.unlocked ? "text-white" : "text-white/50"
          }`}
          style={{ fontFamily: "Orbitron, sans-serif" }}
        >
          {a.title}
        </div>
        <div
          className={`text-xs mt-0.5 ${a.unlocked ? "text-white/70" : "text-white/40"}`}
        >
          {a.description}
        </div>
      </div>
      <span
        className={`text-[10px] uppercase tracking-[0.3em] font-black flex-shrink-0 ${
          a.unlocked ? "" : "text-white/30"
        }`}
        style={{ color: a.unlocked ? "#FFD400" : undefined, fontFamily: "Orbitron, sans-serif" }}
      >
        {a.unlocked ? "Unlocked" : "Locked"}
      </span>
    </div>
  );
};

export const AchievementsView = ({ open, onClose, state }) => {
  const items = evaluateAchievements(state);
  const unlockedCount = items.filter((i) => i.unlocked).length;
  return (
    <ViewModal
      open={open}
      onClose={onClose}
      title="Achievements"
      subtitle={`${unlockedCount} / ${items.length} unlocked`}
      testId="achievements-view"
    >
      <div className="flex flex-col gap-3">
        {items.map((a) => (
          <AchievementRow key={a.id} a={a} />
        ))}
      </div>
    </ViewModal>
  );
};

export default AchievementsView;
